// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1E4uu","large":"styles_large__zFJh3"};